import React, { useState } from 'react';
import { OnboardingFlow } from './pages/OnboardingFlow';
import { MerchantDashboard } from './pages/MerchantDashboard';
export function App() {
  const [appView, setAppView] = useState<'onboarding' | 'dashboard'>('onboarding');
  if (appView === 'dashboard') {
    return <MerchantDashboard data-id="element-0" />;
  }
  return <div className="min-h-screen bg-white" data-id="element-1">
      <OnboardingFlow onGoToDashboard={() => setAppView('dashboard')} data-id="element-2" />
    </div>;
}